import { Box, Button, Typography } from '@mui/material'
import SSHConfigForm from './SSHConfigForm'
import { useNavigate } from 'react-router-dom'
import S3ConfigForm from './S3ConfigForm'
import { useState } from 'react'

const AddDestinationLocation = () => {
    const navigate = useNavigate();
    const [formType, setFormType] = useState("UserkeyFlatDirSshDataProvider")

    const renderForm = () => {
        switch (formType) {
        case "UserkeyFlatDirSshDataProvider":
            return <SSHConfigForm  setFormType = {setFormType}/>;
        case "S3MultiLevelDataProvider":
            return <S3ConfigForm  setFormType = {setFormType}/>;
        default:
            return null;
        }
    }

    return (
        <>
            <Button
                variant="tertiary"
                size="small"
                sx={{ alignSelf: "flex-start" }}
                onClick={() => navigate("/file-download")}
            >
                Back
            </Button>

            <Box sx={{ display: "flex", flexDirection: "column", gap: "36px", height: "100%" }} marginX={5}>
                <Typography textAlign="center" variant="h4" fontSize="40px" fontWeight="600">
                    New destination location
                </Typography>
               
                {renderForm()}
            </Box>
        </>

    )
}

export default AddDestinationLocation